exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-description-item {\n  display: block;\n  text-align: center;\n  margin-bottom: 5px; }\n\n.menu-description-item--title {\n  text-transform: uppercase;\n  margin-top: 10px;\n  margin-bottom: 10px; }\n\n.menu-description-item--header {\n  font-weight: bold;\n  font-size: 16px;\n  margin-top: 14px;\n  margin-bottom: 14px; }\n\n.menu-description-item--comment {\n  color: gray;\n  font-size: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/ulalachef/ulalachef-dashboard/src/app/components/home/reservation-details/reservation-details.component.scss
// module id = ../../../../../src/app/components/home/reservation-details/reservation-details.component.scss
// module chunks = main